import React, { useState, useEffect } from "react";
import Paginator from "../../Components/Paginator/Paginator";

const TableDocuments = ({ data }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [filteredData, setFilteredData] = useState(data);

  useEffect(() => {
    setFilteredData(data);
  }, [data]);
  
  useEffect(() => {
    const totalItems = filteredData.length;
    setTotalPages(totalItems > 0 ? Math.ceil(totalItems / itemsPerPage) : 1);
  }, [filteredData, itemsPerPage]);

  useEffect(() => {
    if (filteredData.length === 0) {
      setTotalPages(1);
      setCurrentPage(1);
    }
  }, [filteredData]);

  const onPageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div className="row mt-24">
      <div className="col-12">
        <div className="card -raspberry">
          <div className="row">
            <div className="col-12 col-md-6 col-lg-4">
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Buscar..."
                  onChange={(e) => {
                    const searchTerm = e.target.value.toLowerCase();
                    setFilteredData(
                      data.filter((row) =>
                        row.some((cell) =>
                          String(cell).toLowerCase().includes(searchTerm)
                        )
                      )
                    );
                  }}
                />
                <span className="input-group-text -raspberry">
                  <i className="fa-solid fa-magnifying-glass"></i>
                </span>
              </div>
            </div>
          </div>

          <div className="row mt-32">
            <div className="col-12">
              <table className="rounded-corners">
                <thead>
                  <tr>
                    <th>Documento</th>
                    <th>Usuario</th>
                    <th>Fecha</th>
                    <th>Estado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((row, index) => (
                    <tr key={index}>
                    {row.map((cell, cellIndex) => {
                     
                      if (cell === row[3]) {
                        return (
                          <td className="pl-16" key={cellIndex}>
                            <span className={`pill ${cell === 'Aprobado' ? '-success' : cell === 'Pendiente' ? '-warning' : '-danger'}`}>
                              {cell}
                            </span>
                          </td>
                        );
                      }
                      return <td className="pl-16" key={cellIndex}>{cell}</td>;
                    })}
                  </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="row mt-40">
            <div className="col d-flex justify-content-end">
              <Paginator currentPage={currentPage} totalPages={totalPages} onPageChange={onPageChange} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableDocuments;
